<template>
<div class="library-book-wrap main-1" v-if="book">
  <section class="yf-thumb">当前位置：<nuxt-link to="/library">图书馆</nuxt-link> &gt; {{ book.bookName }}</section>
  <section class="book-info clearfix">
    <div class="cover left">
      <img :src="book.image" alt="">
    </div>
    <div class="info left">
      <div class="line-0 clearfix">
        <p class="left">{{ book.bookName }}</p>
        <p class="right"><span class="yf-text_blue-1">{{ book.viewcount }}</span> 人看过</p>
      </div>
      <div class="line-1"><span class="yf-text_blue-1">{{ book.author }}</span> 著/ {{ new Date(book.publishingAt.slice(0, 10)).toLocaleDateString('zh-cn', { year: 'numeric', month: 'long', day: 'numeric' }) }} / <span class="yf-text_blue-1">{{ book.press }}</span></div>
      <div class="line-2" v-html="book.introduce"></div>
      <div class="line-3 clearfix">
        <button class="left clearfix" @click="zan">
          <i class="left iconfont icon-ding"></i>
          <span class="left">{{ book.thumbsup }}</span>
        </button>
        <button class="left clearfix" @click="down">
          <i class="left iconfont icon-cai"></i>
          <span class="left">{{ book.thumbsdown }}</span>
        </button>
      </div>
    </div>
  </section>
  <section class="book-chapter">
    <div class="title">章节目录</div>
    <ul class="chapter-list">
      <li class="ellipsis" v-for="(item, index) of book.section" :key="item.id">{{ index + 1 }}、<nuxt-link :to="`/library/${$route.params.book + '/' + item.id}`" :title="item.sectionName">{{ item.sectionName }}</nuxt-link></li>
    </ul>
  </section>
</div>
</template>

<script>
export default {
  scrollToTop: true,
  async asyncData ({ params, $axios }) {
    let book = await $axios._get('/Books/Detail', { bookid: +params.book })
    // console.log(book)
    return {
      book
    }
  },
  methods: {
    zan (e) {
      e.target.disabled = true
      this.$axios._post('/Books/Zan', {
        bookid: this.book.id
      }).then(() => {
        this.book.thumbsup++
      }).finally(() => {
        e.target.disabled = false
      })
    },
    down (e) {
      e.target.disabled = true
      this.$axios._post('/Books/Cai', {
        bookid: this.book.id
      }).then(() => {
        this.book.thumbsdown++
      }).finally(() => {
        e.target.disabled = false
      })
    }
  }
}
</script>

<style lang="less">
.library-book-wrap {
  padding: 40px 0;
  .book-info {
    padding: 50px 28px; border: 1px solid #eaeaea; margin-top: 20px; background-image: linear-gradient(to bottom, #f8f7f6, #fff, #fff, #fff, #fff, #fff);
    .cover {
      width: 140px; height: 180px;
      img {
        width: 140px; height: 180px;
      }
    }
    .info {
      margin-left: 40px; width: 915px; font-size: 14px;
      .line-0 {
        .left { font-size: 18px; font-weight: bold; }
        .right {
          color: #999999;
          span {
            font-style: italic; vertical-align: -5%;
          }
          .yf-text_blue-1 {
            font-size: 24px;
          }
        }
      }
      .line-1 {
        margin-top: 10px; color: #666666;
      }
      .line-2 {
        margin-top: 5px; line-height: 1.8; height: 50px; overflow: hidden; color: #999999;
      }
      .line-3 {
        margin-top: 10px;
        button {
          min-width: 120px; height: 40px; line-height: 40px; border-radius: 20px; text-align: left; padding-left: 20px; font-size: 18px;
          .iconfont {
            font-size: 22px;
            &.icon-cai {
              line-height: 45px;
            }
          }
          &:first-child {
            margin-right: 15px; background-color: #fcdcdc; border: 1px solid #febebe; color: #ff6666;
          }
          &:last-child {
            background-color: #eee; border: 1px solid #e1e1e1;
          }
        }
      }
    }
  }
  .book-chapter {
    margin-top: 18px; border: 1px solid #eaeaea; color: #666666;
    .title {
      line-height: 58px; padding-left: 50px; background-color: #fafafa; border-bottom: 1px solid #eaeaea;
    }
    .chapter-list {
      padding: 20px 50px 50px; overflow: hidden;
      li {
        float: left; border-bottom: 1px dashed #eaeaea; padding: 20px 0; width: 330px; margin-top: 10px;
        a:hover {
          text-decoration: underline;
        }
        &:not(:nth-child(3n + 1)) {
          margin-left: 50px;
        }
      }
    }
  }
}
</style>
